import { render, staticRenderFns } from "./ActionListApproveHeader.vue?vue&type=template&id=53f96eaa&"
import script from "./ActionListApproveHeader.vue?vue&type=script&lang=ts&"
export * from "./ActionListApproveHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports